import { render, staticRenderFns } from "./CardQuote.vue?vue&type=template&id=1f3a2187&scoped=true&"
import script from "./CardQuote.vue?vue&type=script&lang=js&"
export * from "./CardQuote.vue?vue&type=script&lang=js&"
import style0 from "./CardQuote.vue?vue&type=style&index=0&id=1f3a2187&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f3a2187",
  null
  
)

export default component.exports